import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[hideHeaderMenuOnPrint]',
  standalone: true,
})
export class HideHeaderMenuOnPrintDirective implements AfterViewInit {
  private styleId = 'hide-header-menu-on-print-style';

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      // Find the goa-app-header element
      const appHeader = this.el.nativeElement?.querySelector(
        'goa-app-header'
      ) as HTMLElement & { shadowRoot: ShadowRoot };

      if (!appHeader?.shadowRoot) {
        console.warn('Could not find goa-app-header shadow root');
        return;
      }

      // Inject style into app-header shadow DOM
      const appHeaderStyle = this.renderer.createElement('style');
      this.renderer.setAttribute(
        appHeaderStyle,
        'id',
        `${this.styleId}-header`
      );
      appHeaderStyle.textContent = `
        @media print {
          goa-popover,
          .menu-toggle-area,
          button[data-testid="menu-toggle"],
          .app-header-popover,
          .mobile-menu,
          [class*="menu"],
          [class*="toggle"] {
            display: none !important;
            visibility: hidden !important;
          }
        }
      `;
      this.renderer.appendChild(appHeader.shadowRoot, appHeaderStyle);

      // Find the goa-popover inside app-header shadow DOM
      const popover = appHeader.shadowRoot.querySelector(
        'goa-popover'
      ) as HTMLElement & { shadowRoot: ShadowRoot };

      if (popover?.shadowRoot) {
        // Inject style into popover shadow DOM as well
        const popoverStyle = this.renderer.createElement('style');
        this.renderer.setAttribute(
          popoverStyle,
          'id',
          `${this.styleId}-popover`
        );
        popoverStyle.textContent = `
          @media print {
            :host,
            .popover-content,
            section,
            div {
              display: none !important;
              visibility: hidden !important;
            }
          }
        `;
        this.renderer.appendChild(popover.shadowRoot, popoverStyle);
      }
    }, 0);
  }
}
